<template>
    <v-container>
        <v-row class="justify-center text-h4 font-weight-light my-1">
            <slot />
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'PageSubtitle',
}
</script>

<style scoped>

</style>